// src/config.js
const config = {
  development: {
    apiBaseUrl: 'http://localhost:3001/api',
    serverUrl: 'http://localhost:3001'
  },
  production: {
    apiBaseUrl: '/api',
    serverUrl: 'https://krlkimya.com'
  }
};

const env = process.env.NODE_ENV || 'development';
export const { apiBaseUrl, serverUrl } = config[env];

export default config[env];
